// eslint-disable-next-line import/no-extraneous-dependencies
import React, { PropsWithChildren, ReactNode } from 'react';
// eslint-disable-next-line import/no-extraneous-dependencies
import styled from 'styled-components';
import { KitFlexCol, KitFlexRow, KitFlexWrapRow } from './KitFlexbox';
import constants from '../common/theme/constants';

const Title = styled.div`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
  font-size: ${constants.fontSize.p}rem;
  color: ${({ theme }) => theme.displayNumber.title};
  padding-bottom: ${constants.spacing.absolute.xs}px;
`;

const Value = styled.div`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.normal};
  font-size: ${constants.fontSize.h1}rem;
  color: ${({ theme }) => theme.displayNumber.value};
  float: left;
`;

const Unit = styled.div`
  font-family: ${({ theme }) => theme.font.fontFamily};
  font-weight: ${constants.fontWeight.light};
  font-size: ${constants.fontSize.h3}rem;
  color: ${({ theme }) => theme.displayNumber.unit};
  float: right;
  align-self: flex-end;
  padding-bottom: 0.25rem;
  padding-left: ${constants.spacing.absolute.xs}px;
`;

const SpacedCol = styled(KitFlexCol)`
  padding: ${constants.spacing.absolute.xl}px;
`;

const SpacedRow = styled(KitFlexRow)`
  padding: ${constants.spacing.absolute.m}px;
`;

interface KitDisplayClassNameProps extends PropsWithChildren {
  className?: string;
}

interface KitDisplayNumberProps {
  children: ReactNode;
}

type KitDisplayUnitDef<T> = React.FC<T> & {
  Title: React.FC<PropsWithChildren>;
  Value: React.FC<PropsWithChildren>;
  Unit: React.FC<PropsWithChildren>;
};

interface DisplayItemInterface {
  title: string;
  value: unknown;
  unit?: string;
  qaId?: string;
}

export interface KitDisplayNumberSetProps {
  vertical?: boolean;
  displayItems: DisplayItemInterface[];
}

const KitDisplayTitle: React.FC<KitDisplayClassNameProps> = ({ children, className }) => {
  return <Title className={className}>{children}</Title>;
};

const KitDisplayValue: React.FC<KitDisplayClassNameProps> = ({ children, className }) => {
  return <Value className={className}>{children}</Value>;
};

const KitDisplayUnit: React.FC<KitDisplayClassNameProps> = ({ children, className }) => {
  return <Unit className={className}>{children}</Unit>;
};

export const KitDisplayNumber: KitDisplayUnitDef<KitDisplayNumberProps> = ({ children }) => {
  return <div>{children}</div>;
};

KitDisplayNumber.Title = KitDisplayTitle;
KitDisplayNumber.Value = KitDisplayValue;
KitDisplayNumber.Unit = KitDisplayUnit;

const KitDisplayNumbers: React.FC<KitDisplayNumberSetProps> = ({ vertical, displayItems }) => {
  if (vertical) {
    return (
      <KitFlexCol>
        {displayItems.map((item) => (
          <SpacedRow key={`${item.title}-${item.value}`}>
            <KitDisplayNumber>
              <KitDisplayNumber.Title>{item.title}</KitDisplayNumber.Title>
              <KitFlexRow data-qa-id={item.qaId}>
                <KitDisplayNumber.Value>{item.value as string}</KitDisplayNumber.Value>
                {item.unit && <KitDisplayNumber.Unit>{item.unit}</KitDisplayNumber.Unit>}
              </KitFlexRow>
            </KitDisplayNumber>
          </SpacedRow>
        ))}
      </KitFlexCol>
    );
  }
  return (
    <KitFlexWrapRow>
      {displayItems.map((item) => (
        <SpacedCol key={`${item.title}-${item.value}`}>
          <KitDisplayNumber>
            <KitDisplayNumber.Title>{item.title}</KitDisplayNumber.Title>
            <KitFlexRow data-qa-id={item.qaId}>
              <KitDisplayNumber.Value>{item.value as string}</KitDisplayNumber.Value>
              {item.unit && <KitDisplayNumber.Unit>{item.unit}</KitDisplayNumber.Unit>}
            </KitFlexRow>
          </KitDisplayNumber>
        </SpacedCol>
      ))}
    </KitFlexWrapRow>
  );
};

export default KitDisplayNumbers;
